import { Droplets, Award, TrendingUp } from 'lucide-react';
import { useState, useEffect } from 'react';

export default function Impact() {
  const [waterCounter, setWaterCounter] = useState(14235);

  useEffect(() => {
    const interval = setInterval(() => {
      setWaterCounter((prev) => prev + Math.floor(Math.random() * 3));
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Dein Erfolg. Dein Impact.
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Erreiche deine Ziele und mache gleichzeitig die Welt ein Stück besser
          </p>
        </div>

        {/* 2-Card Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12 max-w-4xl mx-auto">
          {/* Card 1: Launch Bonus */}
          <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border-2 border-amber-200">
            <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mb-6 shadow-md">
              <Award className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Launch-Bonus</h3>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Schaffst du 5 Kilo in 7 Tagen – bekommst du dein Geld zurück.
            </p>
            <div className="bg-white rounded-xl p-4 border-2 border-amber-300">
              <p className="text-amber-700 font-bold text-lg text-center">
                5 kg = 0 € Investment
              </p>
            </div>
          </div>

          {/* Card 2: Live Counter */}
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border-2 border-blue-200">
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-6 shadow-md">
              <TrendingUp className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Challenge-Erfolge</h3>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Unsere Community wächst täglich und erreicht gemeinsam ihre Ziele.
            </p>
            <div className="bg-white rounded-xl p-4 border-2 border-blue-300">
              <p className="text-blue-700 font-bold text-2xl text-center">
                {waterCounter.toLocaleString('de-DE')}
              </p>
              <p className="text-blue-600 text-sm text-center mt-1">
                Erfolgreiche Teilnehmer
              </p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-2xl p-8 lg:p-12 text-white text-center">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl lg:text-3xl font-bold mb-4">
              Werde Teil der Transformation
            </h3>
            <p className="text-lg text-green-100 mb-8">
              Tausende haben bereits ihre Ziele erreicht. Starte jetzt deine 7-Tage-Challenge und erlebe, wie sich dein Körper und dein Leben verändern.
            </p>
            <button className="bg-white text-green-700 px-8 py-4 rounded-xl font-semibold hover:bg-green-50 transition-colors shadow-lg">
              Aktionspreis sichern – solange Plätze frei sind
            </button>
            <p className="text-sm text-green-100 mt-2">
              Nur 100 Plätze – danach 149 €.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
